import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'fl-dummy-component',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DummyComponent {}
